import React from "react";

interface InputRadioProps {
  labelName: string;
  id: string;
  name: string;
  checked: boolean;
  value?: string | boolean | any;
  setValue: (value: any) => void;
  boolean?: boolean;
  booleanValue?: boolean;
}

export const InputRadioCustom: React.FC<InputRadioProps> = ({
  labelName,
  id,
  name,
  checked,
  value,
  setValue,
  boolean = false,
  booleanValue,
}) => {
  const onChange = () => {
    setValue(boolean ? booleanValue : value);
  };

  return (
    <label
      htmlFor={id}
      className={`cursor-pointer flex items-center gap-2 select-none
        px-3 py-1 rounded-full border
        transition-colors
        ${
          checked
            ? "bg-main text-white border-main shadow-md"
            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
        }
        `}
    >
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="hidden"
      />
      {/* Cercle personnalisé */}
      <span
        className={`w-5 h-5 rounded-full border-2 flex items-center justify-center
          ${
            checked
              ? "border-white bg-white"
              : "border-gray-400 bg-white"
          }
        `}
      >
        {checked && (
          <span className="w-3 h-3 bg-main rounded-full block"></span>
        )}
      </span>
      <span className="text-sm font-medium">{labelName}</span>
    </label>
  );
};
